import { useQuery } from '@tanstack/react-query';
import Api, { withAcl } from 'hooks/Api';
import { useAdminParams } from 'utils/helpers';
import { useProvider } from 'utils/providers/Provider';
import { Conversation } from 'utils/types';

import { CONVERSATIONS } from '../utils/constants';

export default function useGetConversations(
  params: { [key: string]: any } = {},
) {
  const { accountId, accountUserId } = useAdminParams();
  const { state } = useProvider();
  const args = state;

  return useQuery<Conversation[], Error>({
    queryKey: [CONVERSATIONS, params],
    queryFn: async () => {
      const api = new Api(args);

      if (params?.keyword) {
        params.keyword = params.keyword.replace('+', '');
      }

      const { data } = await api.get(
        await withAcl({
          account: {
            url: 'api/v1/channels/toad/conversations',
            params,
          },
          admin: {
            url: `api/v2/accounts/${accountId}/users/${accountUserId}/channels/toad/conversations`,
            params,
          },
        }),
      );

      return data;
    },
  });
}
